import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_CONSULTATION_HISTORY = 'GET_CONSULTATION_HISTORY';
export const GET_CONSULTATION_HISTORY_SUCCESS =
  'GET_CONSULTATION_HISTORY_SUCCESS';
export const GET_CONSULTATION_HISTORY_FAILURE =
  'GET_CONSULTATION_HISTORY_FAILURE';

// Action Creators
export const getConsultationHistory = () => ({
  type: GET_CONSULTATION_HISTORY,
});

export const getConsultationHistorySuccess = (users) => ({
  type: GET_CONSULTATION_HISTORY_SUCCESS,
  payload: users,
});

export const getConsultationHistoryFailure = (error) => ({
  type: GET_CONSULTATION_HISTORY_FAILURE,
  payload: error,
});

// Thunk Function
export const getConsultationHistoryCallAPI = (external, data) => {
  return async (dispatch) => {
    dispatch(getConsultationHistory());
    try {
      const response = await getMethodWithToken(
        url.consultationHistory + data,
        external.isDownload ? true : false
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getConsultationHistorySuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getConsultationHistoryFailure(error?.message));
    }
  };
};
